import { Link } from 'react-router-dom'

export default function Privacidad() {
  return (
    <div className="page" style={{ maxWidth: 800, margin: '0 auto' }}>
      <div className="page-header">
        <p className="page-label">Legal</p>
        <h1 className="page-title">Política de Privacidad</h1>
        <div className="page-divider"></div>
      </div>

      <div style={{ lineHeight: 1.9, fontSize: '0.85rem', color: 'var(--text-muted)' }}>

        <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '1.2rem', fontWeight: 300, color: 'var(--text)', marginBottom: '0.75rem', marginTop: '2rem' }}>
          1. Responsable del tratamiento
        </h2>
        <p>
          <strong style={{ color: 'var(--text)' }}>Bar El Rincón de la Escandella</strong><br />
          C. Bélgica, 1 · 03698 Alicante<br />
          Email: Elrincondelaescandella2025@gmail.com
        </p>

        <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '1.2rem', fontWeight: 300, color: 'var(--text)', marginBottom: '0.75rem', marginTop: '2rem' }}>
          2. Datos que recogemos
        </h2>
        <p>Al hacer una reserva (o al registrarte) recogemos:</p>
        <ul style={{ paddingLeft: '1.5rem', marginTop: '0.5rem' }}>
          <li>Nombre y apellidos</li>
          <li>Dirección de correo electrónico</li>
          <li>Número de teléfono (opcional)</li>
          <li>Datos de la reserva (fecha, hora, número de personas, notas)</li>
        </ul>

        <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '1.2rem', fontWeight: 300, color: 'var(--text)', marginBottom: '0.75rem', marginTop: '2rem' }}>
          3. Finalidad y base legal
        </h2>
        <p>Usamos tus datos para:</p>
        <ul style={{ paddingLeft: '1.5rem', marginTop: '0.5rem' }}>
          <li><strong style={{ color: 'var(--text)' }}>Gestión de reservas</strong> — base legal: ejecución de un contrato (art. 6.1.b RGPD)</li>
          <li><strong style={{ color: 'var(--text)' }}>Comunicaciones sobre tu reserva</strong> — confirmaciones, recordatorios y cancelaciones</li>
          <li><strong style={{ color: 'var(--text)' }}>Cumplimiento legal</strong> — base legal: obligación legal (art. 6.1.c RGPD)</li>
        </ul>
        <p style={{ marginTop: '0.75rem' }}>No cedemos tus datos a terceros salvo obligación legal.</p>

        <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '1.2rem', fontWeight: 300, color: 'var(--text)', marginBottom: '0.75rem', marginTop: '2rem' }}>
          4. Conservación de datos
        </h2>
        <p>Conservamos tus datos mientras mantengas una cuenta activa y durante un máximo de <strong style={{ color: 'var(--text)' }}>2 años</strong> después de tu última reserva o interacción, salvo obligación legal de conservarlos más tiempo.</p>

        <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '1.2rem', fontWeight: 300, color: 'var(--text)', marginBottom: '0.75rem', marginTop: '2rem' }}>
          5. Tus derechos
        </h2>
        <p>Tienes derecho a:</p>
        <ul style={{ paddingLeft: '1.5rem', marginTop: '0.5rem' }}>
          <li><strong style={{ color: 'var(--text)' }}>Acceso</strong> — saber qué datos tenemos sobre ti</li>
          <li><strong style={{ color: 'var(--text)' }}>Rectificación</strong> — corregir datos inexactos</li>
          <li><strong style={{ color: 'var(--text)' }}>Supresión</strong> — solicitar que eliminemos tus datos</li>
          <li><strong style={{ color: 'var(--text)' }}>Portabilidad</strong> — recibir tus datos en formato estructurado</li>
          <li><strong style={{ color: 'var(--text)' }}>Oposición</strong> — oponerte a ciertos tratamientos</li>
        </ul>
        <p style={{ marginTop: '0.75rem' }}>
          Para ejercer tus derechos, escríbenos a <strong style={{ color: 'var(--text)' }}>Elrincondelaescandella2025@gmail.com</strong> indicando tu solicitud y una copia de tu DNI. Tienes también derecho a presentar una reclamación ante la <a href="https://www.aepd.es" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--gold)' }}>Agencia Española de Protección de Datos (AEPD)</a>.
        </p>

        <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '1.2rem', fontWeight: 300, color: 'var(--text)', marginBottom: '0.75rem', marginTop: '2rem' }}>
          6. Seguridad
        </h2>
        <p>Aplicamos medidas técnicas y organizativas para proteger tus datos: cifrado de contraseñas, comunicaciones HTTPS y acceso restringido a los datos.</p>

        <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '1.2rem', fontWeight: 300, color: 'var(--text)', marginBottom: '0.75rem', marginTop: '2rem' }}>
          7. Cookies
        </h2>
        <p>Esta web no utiliza cookies de seguimiento ni publicidad. Solo se usan las estrictamente necesarias para el funcionamiento de la sesión.</p>

        <p style={{ marginTop: '2.5rem', fontSize: '0.75rem' }}>
          Última actualización: junio 2026
        </p>

        <div style={{ marginTop: '2rem' }}>
          <Link to="/" style={{ color: 'var(--gold)', fontSize: '0.75rem', letterSpacing: '0.15em', textTransform: 'uppercase', textDecoration: 'none' }}>
            ← Volver al inicio
          </Link>
        </div>
      </div>
    </div>
  )
}
